import classNames from 'classnames';
import React from 'react';

interface Props {
    icon: string;
    size?: 'large' | '2x' | '3x' | '4x' | '5x';
    highlight?: boolean;
    left?: boolean;
    offsetLeft?: boolean;
    offsetRight?: boolean;
    className?: string;
}

class Icon extends React.Component<Props> {
    getVariations() {
        const variations: { [elem: string]: any } = {
            'icon--highlight': this.props.highlight,
            'icon--left': this.props.left,
            'icon--offset-left': this.props.offsetLeft,
            'icon--offset-right': this.props.offsetRight,
        };

        variations[`icon--${this.props.size}`] = this.props.size;

        return variations;
    }

    render() {
        const classes = classNames(
            'icon',
            `icon--${this.props.icon}`,
            this.getVariations(),
            this.props.className
        );
        return <span className={classes} />;
    }
}

export default Icon;



// WEBPACK FOOTER //
// ./js/launch/components/Icon.tsx